import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Renderer2} from '@angular/core';
import {SymbolControl} from '../../models/uiArtefakt';
import {UIAusrichtung} from '../../models/uiAusrichtung';
import {ShellConfigService} from '../../services/shell-config.service';
import {CoreSettings, SETTINGS} from '@lv1871/core';

class Image {
  key: string;
  filename: string;
}

const IMAGE_MAP = [
  {
    key: 'BildElektronischeUnterschrift',
    filename: 'LV1871_plus_inSign.png'
  }
] as Image[];

@Component({
    selector: 'lv-symbol',
    templateUrl: './symbol.component.html',
    styleUrls: ['./symbol.component.scss'],
    standalone: false
})
export class SymbolComponent implements OnInit, AfterViewInit {


  public uiAusrichtung: UIAusrichtung;
  public isImage: boolean = false;

  private _uiArtefakt: SymbolControl;

  constructor(@Inject(SETTINGS) private _settings: CoreSettings, private _shellConfigService: ShellConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): SymbolControl {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: SymbolControl) {
    if (IMAGE_MAP.map(image => image.key).includes(uiArtefakt.Symbolbezeichnung)) {
      this.isImage = true;
    }
    this._uiArtefakt = uiArtefakt;
  }

  public ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
  }

  public getImageFilename(): string {
    return IMAGE_MAP.filter(image => image.key === this._uiArtefakt.Symbolbezeichnung)[0].filename;
  }

  getHostname() {
    return this._settings.app_root_url;
  }
}
